import index from "./viewLogs.vue";
export default index;
